import { parseCSV } from './csv';

export function parseDonorsCSV(text) {
  return parseCSV(text);
}

export function formatDonorAmount(amount) {
  const value = Number(String(amount).replace(/,/g, ''));
  return Number.isNaN(value) ? amount : value.toLocaleString('en-IN');
}

export function parseDonorAmount(amount) {
  return Number(String(amount).replace(/,/g, '')) || 0;
}

export function buildDonorSpotlightQueue(donors) {
  return [...donors]
    .filter((donor) => donor.name)
    .sort(() => Math.random() - 0.5);
}
